import { EnvironmentConfiguration, environments } from 'src/app/environment/services/environment.configuration';
const environment = new EnvironmentConfiguration(environments);

export class ConstantValues {
  public static readonly env = environment;
  public static readonly pageLimit = 10;
  public static readonly unknownError = "Unknown Error";
  public static readonly timeoutErrorMessage = "Connection timed out!";
  public static readonly membershipApiUrl = Object.freeze({
    bpgList: '/userservice/bpg/list',
    sitebpgList: '/userservice/allBpg/list',
    interestList: '/userservice/areaofimpact/list',
    skillsList: '/userservice/skills/list',
    demographicLIst: '/userservice/demographics/list',
    membershipSaveApi: '/userservice/membershipform/save',
    retrieveDetailsOfMembershipForm: '/userservice/membershipform/retrieveDetails/',
    excludeBpgApi: '/userservice/virtualmembership/bpg/list/',
    siteList : '/userservice/chapter/getSiteListBybpgId',
    chapterEmailList: '/userservice/chapter/membersDetails',
    getNaacAdminChapters: '/userservice/hoshin/getBpgAndSiteList',
    landingDto: {
      "filter": { "userId": "0", "siteId": localStorage.getItem('userSiteId') },
      "moduleId": 0,
      "page": 0,
      "presentRole": "string",
      "searchTerm": "string",
      "size": 0,
      "sortDirection": "ASC",
      "sortProperty": "string",
      "uid": "string",
    }
  });

  public static readonly userManagementApiUrl = Object.freeze({
    userManagementUrl: localStorage.getItem('userManagementUrl'),
    registerVirtualSiteUrl: '/userservice/virtualmembership/site/',
    saveAreaOfImpact: '/userservice/areaofimpact/save',
    areaOfImpactList: '/userservice/areaofimpact/list',
    deleteAreaOfImpact: '/userservice/areaofimpact/delete/',
    demographicsList: '/userservice/demographics/list',
    saveDemographic: '/userservice/demographics/save',
    deleteDemographic: '/userservice/demographics/delete/',
    bpgList: '/userservice/bpg/list',
    saveBpg: '/userservice/bpg/save',
    deleteBpg: '/userservice/bpg/delete/',
    skillList: '/userservice/skills/list',
    saveSkill: '/userservice/skills/save',
    deleteSkill: '/userservice/skills/delete/',
    siteList: '/userservice/site/list',
    siteMap : '/userservice/site/listSitesforBpg',
    eachBpg : '/userservice/bpg/map',
    chapterDetails: '/userservice/chapter/details',
    withdrawMembership: '/userservice/membership/delete/',
    chapterLeadershipDetails: '/userservice/chapter/leadershipDetails',
    userSiteDetails: '/userservice/site/id',
    userList: '/userservice/user/dropdown/list',
    siteSave: '/userservice/site/save',
    deleteSite: '/userservice/site/delete/',
    chapterList: '/userservice/chapter/list',
    saveChapter: '/userservice/chapter/save',
    deleteChapter: '/userservice/chapter/delete/',
    adminList: '/userservice/admin/pages/',
    deleteAdmin: '/userservice/admin/delete/',
    saveAdmin: '/userservice/admin/save/',
    getAWSurl: '/userservice/aws/url',
    listAllSites: '/userservice/site/listSites',
    listAllChapters: '/userservice/chapter/pages',
    listFullChapters : '/userservice/chapter/isActive',
    bpgListPage: '/userservice/bpg/pages',
    skillListPage: '/userservice/skills/pages',
    areaOfImpactListPage: '/userservice/areaofimpact/pages',
    chapterAdminList: '/userservice/chapterAdmin/pages/',
    saveChapterAdmin: '/userservice/chapterAdmin/save/',
    chapterListByBpg: '/userservice/chapterbybpgsite/list/',
    deleteChapterAdmin: '/userservice/chapteradmin/delete',
    diSave: '/userservice/di/save',
    updateEmail : '/userservice/admin/update',
    diAdd: '/userservice/di/add/master',
    diNewsAdd: '/userservice/di/add/news',
    diResourceAdd: '/userservice/di/add/resource',
    diReTeamAdd: '/userservice/di/add/reTeam',
    diNaacAdd: '/userservice/di/add/naac',
    savenaacAdmin: '/userservice/naac/addNaccAdmin',
    naacadminList : '/userservice/naacAdmin/details',
    deletenaacAdmin: '/userservice/naacAdmin/delete/',

    getDiMasterList: '/userservice/di/get/list',
    getDiNewsList: '/userservice/di/get/newsList',
    getDiResouceList: '/userservice/di/get/resourceList',
    getReteamList: '/userservice/di/get/reTeamList',
    getNaacList: '/userservice/di/get/NaacList',
    deleteDi: '/userservice/di/delete/',

    addGallery: '/userservice/addChapterGallery',
    getGalleryList: '/userservice/chapterGalleryList',
    deleteChapterGallery: '/userservice/deleteChapterGallery/',

    getBannerList : '/userservice/diBannerList',
    deleteBannerList : '/userservice/deleteDiBanner/',

    addDocumentsFolder: '/userservice/addDocumentsFolder',
    addDiDocumentsFolder: '/userservice/addDiDocumentsFolder',
    getDocumentsFolderList: '/userservice/documentsFolderList',
    getDiDocumentsFolder: '/userservice/didocumentsFolderList',
    deleteDocumentsFolder: '/userservice/deleteDocumentsFolder/',
    deleteDiDocumentsFolder: '/userservice/deleteDiDocumentsFolder/',
    membershipReport: '/userservice/membershipReport',
    
    naacAddAffinity : '/userservice/naac/addAffinity ',
    addnaacMaster :'/userservice/naac/addNaccDetails',
    addnaacNews : '/userservice/naac/addNews',
    addnaacReTeam : '/userservice/naac/addReTeam',
    addnaacResource : '/userservice/naac/addResource',
    getnaacBannerList : '/userservice/naac/getList',
    getnaacNews : '/userservice/naac/getnewsList',
    getnaacREteam : '/userservice/naac/getReTeamList',
    getnaacResource: '/userservice/naac/getresourceList',
    getnaacAffinity : '/userservice/naac/getAffinityList',
    deleteNaacBanner : '/userservice/naac/deleteNaacBanner/',
    deletenaac : '/userservice/naac/delete',
    addNaacDocumentsFolder : '/userservice/naac/addDocumentsFolder',
    getNaacDocumentsFolder : '/userservice/naac/documentsFolderList',
    deleteNaacDocumentsFolder : '/userservice/deleteNaacDocumentsFolder/',
    deleteNaacAffinity : '/userservice/deleteNaacAffinity/',
    getMapDataforNaac : '/userservice/naac/affinityMap/',
    getsiteDetails : '/userservice/naac/affinitySiteDetails',
    getSummaryDetails : '/userservice/naac/getDashboardDetails',
    getNaacEvents : '/userservice/naac/eventcalendar',
    naacList : '/userservice/naacAffinity/details',

    chapterFolderDetails : '/userservice/chapterFolderList',
    addChapterAnnouncement : '/userservice/chapter/announcement',
    getChapterAnnouncement : '/userservice/chapter/getAnnouncementList',
    deleteChapterAnnouncement : '/userservice/deleteChapterAnnouncement/',
    sendChapterFeedback : '/userservice/chapter/saveFeedback',
    sendChapterNotification : '/userservice/chapter/chapterNotification',
    getChapterFeedback: '/userservice/chapter/feedbackList',

    addChapterBoardMember : '/userservice/chapter/addBoard',
    getChapterBoardMember : '/userservice/chapter/getBoardList',
    deleteChapterBoardMember : '/userservice/chapter/deleteChapterBoard/',
    getChapterStatus : '/userservice/chapter/chapterExist',
    trackPostCastViews : '/userservice/update/podcastCount',
    
    getUserDtls : '/userservice/user/list/byemailIds',
    updateNewSite : '/userservice/site/preference',
    // getNotEnrolledBpg: '/userservice/membership/list/',
    getEnrolledBpg: '/userservice/membershipform/enrolled/',
    getVirtualBpg:  '/userservice/membership/list/',
    saveMembership: '/userservice/membership/save',
    getMembershipsites : '/userservice/site/listSitesforMembership/',
    saveMembershipUserEmail: '/userservice/membership/saveEmail',
    getMembershipGroupSignUpUserDetails : '/userservice/groupMembership/user/details',
    saveMemberhsipGroupDetails : '/userservice/groupMembership/user/save',
    saveAdminBpgSettings : '/userservice/groupMembership/saveBpgs',
    getPastEnrollmentList: '/userservice/pastEnrollments/list/',
    deleteEnrollment: '/userservice/enrollment/delete/',

    getHomePageData: '/userservice/admin/home/data',
    getAdminsChatperData: '/userservice/admin/chapter/data',
    saveUserActionLogs: '/userservice/log/data',
    getpushNotificationLogs: '/userservice/chapter/pushNotification/emailDetails',
    getActualsChapterList : '/userservice/acutals/chapters/list',
    getActualsBPGList : '/userservice/acutals/bpg/list',
    getActualsSiteList : '/userservice/acutals/site/list',
    ergTncSave : '/userservice/save/terms-and-condition',
    ergTncGet : '/userservice/get/terms-and-condition',
    ergTncGetAll : '/userservice/get/terms-and-condition-all',
    appFeedbackSave: '/userservice/save/app-feedback',
    appFeedbackList: '/userservice/get/app-feedback'
});

  public static readonly commonApiUrl = Object.freeze({
    login: '/userservice/login',
    loginMonitor: '/userservice/login/Monitor',
    userRole: '/userservice/roledetails',
    userDetails: '/userservice/user/userdetails',
    eventChapterDropDownList: '/userservice/chapter/dropdown/list',
    userDetailsByEmailId: '/userservice/user/userdetails/emailid',
    checkSiteAffected: '/userservice/siteAffected/details'
  });

  public static readonly modules = Object.freeze({
    membershipModule: 'membership module',
    selfServiceModule: 'self service module',
    eventsModule: 'events module',
    bpgCommonServiceModule: 'bpg common module',
    adminModule: 'admin module',
    financeModule: 'financial module'
  });

  public static readonly eventManagementApiUrl = Object.freeze({
    eventManagementUrl: localStorage.getItem('eventManagementUrl'),
    eventCalendarList: '/eventservice/eventcalendar/list',
    eventTypeList: '/eventservice/event/type',
    hoshinList: '/eventservice/hoshin',
    createEvent: '/eventservice/event/create',
    uploadFile: '/eventservice/uploadFile',
    eventRegistration: '/eventservice/eventRegistration',
    eventRegistrationForGroup: '/eventservice/eventGroupRegistration',
    countOfSignedUser: '/eventservice/event/getCount/signedUser/',
    signedUnsignedUser: '/eventservice/event/getSigned/unsignedUser/',
    eventStatusUpdate: '/eventservice/event/updatestatus',
    createExpense: '/eventservice/expense/create',
    awsUrls: '/eventservice/aws/url',
    eventAttendance: '/eventservice/userattendance/save',
    getExpense: '/eventservice/expenselist/pages',
    expenseStatusUpdate: '/eventservice/expense/updatestatus',
    getSurveyStandardQuestionAnswers: '/eventservice/questionanswers',
    getTakeSurveyList: '/eventservice/getsurvey',
    saveSurveyResponse: '/eventservice/submitsurvey',
    createSurvey: '/eventservice/createsurvey',
    getSurveyQuestions: '/eventservice/surveyquestions',
    getSurveyId: '/eventservice/getSurveyId',
    getSitePrimaryContactSuperAdmin: '/eventservice/expense/siteprimarycontactadmins',
    suveyTakenByUser: '/eventservice/suveyTakenByUser',
    listAttendance: '/eventservice/attendancelist',
    getEventReport: '/eventservice/eventreport/page',
    getGroupSignupDetails : '/eventservice/event/getSignedGroupDetails/',
    removeFromEventGroup : '/eventservice/event/removeFromGroup/',
    getExpenseById: '/eventservice/expense/',
    printEventsInFY: '/eventservice/events/print',
    getBudgetActualsData : '/eventservice/actualslist/pages'
  });

  public static readonly dateFormats = Object.freeze({
    dateFormat: 'yyyy-MM-dd HH:mm:ss'
  });

  public static readonly leadershipPosition = Object.freeze({
    chair: "CHAIR",
    viceChair: "VICE CHAIR",
    communicationChair: "COMMUNICATION CHAIR",
    financeChair: "FINANCE CHAIR"
  });

  public static readonly financeManagementApiUrl = Object.freeze({
    financeManagementUrl: localStorage.getItem('financialManagementUrl'),
    getBudget: '/financeservice/budgetlist/pages',
    saveBudgetUrl: '/financeservice/budget/create',
    getHoshinsUrl: '/financeservice/get/hoshins',
    deleteBudget: '/financeservice/budget/delete/',
    cloneHoshineUrl: '/financeservice/budget/copy/',
    getBaseHoshinMasterForHoshinId: '/financeservice/get/baseHoshin/',
    getHoshinForSingleUser: '/financeservice/getHoshin/details',
    getKpiDetails: '/financeservice/getKpis/',
    submitAnnualPlanInitiative: '/financeservice/AnnualPlan/submissionForm',
    annualPlanHistory: '/financeservice/AnnualPlan/history',
    getHoshinYears: '/financeservice/getHoshin/statusByYear',
    saveHoshinReview: '/financeservice/saveHoshinReview',
    saveHoshinGoals: '/financeservice/hoshin/saveGoals',
    saveHoshinInitiative: '/financeservice/hoshin/saveInitiative',
    saveHoshinKpi: '/financeservice/hoshin/savekpi',
    deleteHoshinInitative: '/financeservice/hoshin/deleteInitiative/',
    deleteHoshinKpi: '/financeservice/hoshin/deletekpi/',
    cloneHoshins: '/financeservice/hoshin/cloned/save',
    approveorRejectHoshin : '/financeservice/hoshin/approval',
    submitHoshin: '/financeservice/hoshin/submit',
    getPastHoshins: '/financeservice/hoshins/byChapter',
    getHoshinChapters : '/financeservice/hoshin/chapters/pages',
    getAllChapterBudgetStatuses: '/financeservice/hoshin/statusforAllChapter',
  });


  public static readonly reportData = Object.freeze({
    reportData: [{ "reportName": "ERG dashboard", "reportUrl": environment.reportUrl0, "reportDescription": "View ERG dashboard" },
    { "reportName": "Membership counts by Chapter", "reportUrl": environment.reportUrl1, "reportDescription": "View Membership counts by Chapter" },
    { "reportName": "Membership Details on ERG level", "reportUrl": environment.reportUrl2, "reportDescription": "View Membership Details on ERG level" },
    { "reportName": "Membership Details & ERG Positions", "reportUrl": environment.reportUrl3, "reportDescription": "View Membership Details & ERG Positions" },
    { "reportName": "Member & ERG Roles", "reportUrl": environment.reportUrl4, "reportDescription": "View Member & ERG Roles" }
      , { "reportName": "Events Summary", "reportUrl": environment.reportUrl5, "reportDescription": "View Events Summary" },
    { "reportName": "Budget Request", "reportUrl": environment.reportUrl6, "reportDescription": "View Budget Request" },
    { "reportName": "Annual Plan Details", "reportUrl": environment.reportUrl7, "reportDescription": "View Annual Plan Details" },
    { "reportName": "Calendar Report", "reportUrl": environment.reportUrl8, "reportDescription": "View Calendar Report" },
    { "reportName": "Survey Report", "reportUrl": environment.reportUrl9, "reportDescription": "View Survey Report" },
    { "reportName": "Event Registration", "reportUrl": environment.reportUrl10, "reportDescription": "View Event Registration Report" },
    { "reportName": "ERG User Login", "reportUrl": environment.reportUrl11, "reportDescription": "View ERG User Login Report" }
    ]
  });
}
